import { Display } from "./Display";
import { Profile } from "./Profile";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <Display />
    </div>
  );
}
